const SET_FETCHING = 'mrCollection/SET_FETCHING';
const SET_SUBMITTING = 'mrCollection/SET_SUBMITTING';

export default {
  SET_FETCHING,
  SET_SUBMITTING,
};
